/**
 * Enum маршрутов приложения
 */
export const RoutesEnum = Object.freeze({
  ROOT: '/',
  AUTH: '/auth',
  APP: '/app',
  SETTINGS: '/settings',
  INTEGRATIONS: '/settings/integrations',
  PROJECT: id => `/app/p/${id}`,
  PRIVACY: '/privacy',
  TERMS: '/terms',
  CONSENT: '/consent',
  COOKIES: '/cookies',
  PLANS: '/plans',
  CONTACT: '/contact',
  USE_CASES: '/use-cases',
  RESEARCH: '/research/',
})
